import script from "./SearchableSelectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchableSelectComponent.vue?vue&type=script&setup=true&lang=js"

import "./SearchableSelectComponent.vue?vue&type=style&index=0&id=12da5efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12da5efa"]])

export default __exports__